import { Box, Container } from "@mui/material";
import { ProfileShell } from "./ProfileShell";
import useGlobalStyles from "styles/globalStyles";
import Positions from "components/user/Positions/Positions";
import ProfileInfoSection from "components/user/ProfileInfoSection/ProfileInfoSection";
import { ProfileProvider } from "context/ProfileContext";
import Experiences from "components/user/Experiences/Experiences";
import Educations from "components/user/Educations/Educations";
import Reimbursement from "components/user/Reimbursement/Reimbursement";
import ExportedProcedures from "components/user/ExportedProcedures/ExportedProcedures";
import ProfileDashboard from "components/user/ProfileDashboard/ProfileDashboard";
import { useLocation } from "react-router-dom";

export default function ProfilePage() {
  const globalStyles = useGlobalStyles();
  const location = useLocation();
  const defaultTab = location.state?.tab || "position";
  const defaultDashboardView = location.state?.view;

  return (
    <ProfileProvider>
      <Box className={globalStyles.container} p={3}>

        <Box>
            <ProfileInfoSection />
        </Box>

        <Box mt={3}>
          <ProfileShell defaultTab={defaultTab}>
            {(active) => {
              switch (active) {
                case "position":
                  return (
                    <Positions />
                  );

                case "experience":
                  return (
                    <Experiences />
                  );

                case "education":
                  return (
                    <Educations />
                  );

                case "reimbursement":
                  return (
                    <Reimbursement />
                  );

                case "exported":
                  return (
                    <ExportedProcedures />
                  )

                case "dashboard":
                  return (
                    <ProfileDashboard defaultView={defaultDashboardView} />
                  );

                default:
                  return null;
              }
            }}
          </ProfileShell>
        </Box>

      </Box>
    </ProfileProvider>
  );
}
